import { voiceEventMarker } from '../voiceEventMarker'

export function clearVoiceEventMarker() {
  voiceEventMarker.event = null
}
